export const blogPosts = [
  {
    id: 1,
    title: 'Top 10 Digital Products That Sell Best in 2025',
    excerpt: 'Discover the most profitable digital products and services that are dominating the market this year with proven sales records.',
    category: 'Digital Products',
    author: 'Sarah Johnson',
    date: '2025-01-15',
    readTime: '8 min read',
    image: 'https://public.readdy.ai/ai/img_res/9642f8b789871f8cf653bad57ab7b147.jpg',
  },
  {
    id: 2,
    title: 'How to Choose the Right Digital Service for Your Business',
    excerpt: 'A comprehensive guide to selecting digital services that will maximize your ROI and accelerate business growth.',
    category: 'Business Tips',
    author: 'Michael Chen',
    date: '2025-01-12',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=business%20professional%20analyzing%20digital%20services%20on%20computer%20screen%20with%20charts%20and%20graphs%20in%20clean%20modern%20office%20with%20white%20walls%20and%20natural%20lighting&width=800&height=450&seq=blog2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Best Practices for Secure Online Shopping',
    excerpt: 'Learn essential security tips and best practices to protect yourself while shopping for digital products online.',
    category: 'Security',
    author: 'Emily Rodriguez',
    date: '2025-01-10',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=online%20shopping%20security%20concept%20with%20padlock%20shield%20icon%20and%20secure%20payment%20interface%20on%20laptop%20screen%20in%20clean%20white%20workspace%20with%20modern%20aesthetic&width=800&height=450&seq=blog3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Maximizing Value: Getting the Most from Digital Services',
    excerpt: 'Expert strategies to ensure you get maximum value from your digital service investments and achieve better results.',
    category: 'Guides',
    author: 'David Park',
    date: '2025-01-08',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=value%20optimization%20concept%20showing%20growth%20charts%20success%20metrics%20and%20digital%20analytics%20on%20modern%20computer%20display%20in%20bright%20minimalist%20office%20environment&width=800&height=450&seq=blog4&orientation=landscape',
  },
  {
    id: 5,
    title: 'The Future of E-commerce: Trends to Watch',
    excerpt: 'Explore emerging e-commerce trends and technologies that are shaping the future of online shopping.',
    category: 'Trends',
    author: 'Lisa Thompson',
    date: '2025-01-05',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20e-commerce%20interface%20with%20holographic%20elements%20shopping%20cart%20and%20modern%20technology%20displayed%20on%20sleek%20devices%20in%20clean%20white%20studio%20setting&width=800&height=450&seq=blog5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Quality vs Price: Finding the Perfect Balance',
    excerpt: 'Understanding how to evaluate digital products and services to find the best quality at competitive prices.',
    category: 'Buying Guide',
    author: 'James Wilson',
    date: '2025-01-03',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=quality%20comparison%20concept%20with%20balance%20scale%20premium%20products%20and%20price%20tags%20displayed%20elegantly%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting&width=800&height=450&seq=blog6&orientation=landscape',
  },
];